<script setup lang="ts">
import Skeleton from '~~/src/components/ui/skeleton/Skeleton.vue'
const props = defineProps<{
  columns: string[]
  folderLevel: number
}>()

const isVisible = computed(() => (column: string) => {
  return !props.columns || props.columns.includes(column)
})
</script>

<template>
  <div class="row-elemental animate-pulse border-b border-grayLighter !hover:bg-transparent">
    <div class="drag-indicator" />
    <div
      v-if="isVisible('title')"
      class="elemental-cell title flex items-center gap-2"
      :class="{
        'pl-4': folderLevel === 2,
        'pl-8': folderLevel === 3,
      }"
    >
      <Skeleton class="h-7 w-7 flex-shrink-0" />
      <div class="overflow-hidden pr-7">
        <Skeleton class="h-4 w-32" />
      </div>
    </div>

    <!-- author -->
    <div
      v-if="isVisible('user')"
      class="elemental-cell user flex items-center gap-2 hide-column"
    >
      <Skeleton class="h-4 w-24" />
    </div>

    <!-- type -->
    <div
      v-if="isVisible('elementalTypeId')"
      class="elemental-cell elementalTypeId flex items-center gap-2 hide-column"
    >
      <Skeleton class="h-5 w-5" />
      <Skeleton class="h-5 w-24" />
    </div>

    <!-- createdAt -->
    <div
      v-if="isVisible('createdAt')"
      class="elemental-cell createdAt flex items-center gap-2 hide-column"
    >
      <Skeleton class="h-4 w-24" />
    </div>

    <!-- updatedAt -->
    <div
      v-if="isVisible('updatedAt')"
      class="elemental-cell updatedAt flex items-center gap-2 hide-column"
    >
      <Skeleton class="h-4 w-24" />
    </div>
  </div>
</template>
